import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({ name: 'filter' })
export class FilterPipe implements PipeTransform {
  transform(array: any[], query): any {
    if (!query.value) {
      return array;
    }

    return array.filter(item => _.get(item, query.path) === query.value);
  }
}
